<footer class="border-t border-slate-200 bg-white px-6 py-8 text-center">
    <p class="text-sm text-slate-400">
        &copy; {new Date().getFullYear()} YourBridgeFunds. All rights reserved.
    </p>
</footer>
